import { makeStyles } from 'tss-react/mui';
import NewsComponent from './newsComponent';
import ShowsComponent from './showsComponent';
import BandComponent from './bandComponent';
import ContactComponent from './contactComponent';
import { primaryColor } from '../../assets/colors';
import './content.css';
import { useIsMobile } from '../../utils/useIsMobile';

type Props = {
  newsRef?: React.Ref<HTMLDivElement>;
  showsRef?: React.Ref<HTMLDivElement>;
  bandRef?: React.Ref<HTMLDivElement>;
  contactRef?: React.Ref<HTMLDivElement>;
};

const useStyles = makeStyles()((theme) => ({
  contentContainer: {
    padding: '0px 100px',
  },
  contentContainerMobile: {
    padding: '0px 32px',
  },
  subComponentWrapper: {
    padding: '32px 0px 96px 0px',
    margin: '0px 32px',
  },
  subComponentWrapperMobile: {
    padding: '12px 0px 32px 0px',
  },
  dottedBorder: {
    borderBottom: `2px dotted ${primaryColor}`,
  },
}));

const ContentComponent: React.FC<Props> = ({
  newsRef,
  showsRef,
  bandRef,
  contactRef,
}) => {
  const { classes } = useStyles();
  const isMobile = useIsMobile();
  const subComponentWrapper = isMobile
    ? classes.subComponentWrapperMobile
    : classes.subComponentWrapper;

  return (
    <div
      className={
        isMobile ? classes.contentContainerMobile : classes.contentContainer
      }
    >
      <div
        ref={newsRef}
        className={`${subComponentWrapper} ${classes.dottedBorder}`}
      >
        <NewsComponent />
      </div>
      <div
        ref={showsRef}
        className={`${subComponentWrapper} ${classes.dottedBorder}`}
      >
        <ShowsComponent />
      </div>
      <div
        ref={bandRef}
        className={`${subComponentWrapper} ${classes.dottedBorder}`}
      >
        <BandComponent />
      </div>
      <div ref={contactRef} className={subComponentWrapper}>
        <ContactComponent />
      </div>
    </div>
  );
};

export default ContentComponent;
